import { db } from './config';
import {
  collection,
  addDoc,
  getDocs,
  doc,
  updateDoc,
  deleteDoc
} from 'firebase/firestore';

const COLLECTION_NAME = 'serviceCategories';

const sortByOrder = (a, b) => {
  const orderA = a.order !== undefined ? a.order : 999;
  const orderB = b.order !== undefined ? b.order : 999;
  if (orderA === orderB) {
    return (a.name || '').localeCompare(b.name || '');
  }
  return orderA - orderB;
};

// Get all service categories (admin)
export const getServiceCategories = async () => {
  try {
    const snapshot = await getDocs(collection(db, COLLECTION_NAME));
    const categories = [];
    snapshot.forEach((docSnap) => {
      categories.push({ id: docSnap.id, ...docSnap.data() });
    });
    return categories.sort(sortByOrder);
  } catch (error) {
    console.error('Error getting service categories:', error);
    return [];
  }
};

// Get only active categories (public homepage)
export const getActiveServiceCategories = async () => {
  const all = await getServiceCategories();
  return all.filter((c) => c.active !== false);
};

// Add a new category. Appends to the end of the order.
export const addServiceCategory = async (categoryData) => {
  try {
    const existing = await getServiceCategories();
    const maxOrder = existing.reduce((max, c) => Math.max(max, c.order || 0), 0);

    const newCategory = {
      name: categoryData.name || '',
      description: categoryData.description || '',
      serviceIds: Array.isArray(categoryData.serviceIds) ? categoryData.serviceIds : [],
      active: categoryData.active !== undefined ? categoryData.active : true,
      order: maxOrder + 1,
      createdAt: new Date().toISOString()
    };

    const docRef = await addDoc(collection(db, COLLECTION_NAME), newCategory);
    return { id: docRef.id, ...newCategory };
  } catch (error) {
    console.error('Error adding service category:', error);
    throw error;
  }
};

// Update a category
export const updateServiceCategory = async (id, categoryData) => {
  try {
    const { id: _ignore, ...clean } = categoryData;
    const updated = {
      ...clean,
      updatedAt: new Date().toISOString()
    };
    await updateDoc(doc(db, COLLECTION_NAME, id), updated);
    return { id, ...updated };
  } catch (error) {
    console.error('Error updating service category:', error);
    throw error;
  }
};

// Delete a category
export const deleteServiceCategory = async (id) => {
  try {
    await deleteDoc(doc(db, COLLECTION_NAME, id));
    return id;
  } catch (error) {
    console.error('Error deleting service category:', error);
    throw error;
  }
};
